import React, {useState} from "react";
import "./TracerMain.css";
import { Container } from "react-bootstrap";
import Footer from "../../Component/Footer/Footer";
import Navbar from "../../Component/Navbar/Navbar";
import Delete from "../../images/delete-icon.png";
import Sidebar from "../../Component/Sidebar/SIdebar";
import ProductSchesuleInput from "../../Component/input/ProductScheduleInput";
const ProductScheduleMain = () => {
  const [isActive, setActive] = useState(false);
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <Sidebar handleToggle={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <Navbar isActive={isActive} />
          <Container>
            <div className="head-select">
              <div className="top-bar">
                <ProductSchesuleInput />
              </div>
              <div className="main-select">
                <div className="productSchedule-body">
                  <div className="oper-table">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Recipe ID</th>
                          <th scope="col"></th>
                          <th scope="col">Quntity</th>
                          <th scope="col">Date</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan={2}> xfdiv_nano_v2_toplayer ($0)</td>
                          <td>1500</td>
                          <td>2022/04/11</td>
                          <td>
                          <a href="#">  <img src={Delete} alt="" /></a>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>xfdiv_nano_v2_toplayer ($0)</td>
                          <td>1500</td>
                          <td>2022/04/11</td>
                          <td>
                          <a href="#">  <img src={Delete} alt="" /></a>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>xfdiv_nano_v2_toplayer ($0)</td>
                          <td>1500</td>
                          <td>2022/04/11</td>
                          <td>
                          <a href="#">  <img src={Delete} alt="" /></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="bottom-table">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Designator</th>
                          <th scope="col">Component</th>
                          <th scope="col">Package</th>
                          <th scope="col">Value</th>
                          <th scope="col">Barcode</th>
                          <th scope="col">Stock</th>
                          <th scope="col">Required</th>
                          <th scope="col">Cost</th>
                          <th scope="col">Ordered Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td>-2</td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td>1.5pf</td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td>1.5pf</td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td>1.5pf</td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>0.5k-dx-20-PWB</td>
                          <td>FPC CON 0.5MM 20 </td>
                          <td></td>
                          <td>5k-dx-20-PWB</td>
                          <td></td>
                          <td>0</td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                          <td>
                            <div className="box">
                              {" "}
                              <input type="text" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ProductScheduleMain;
